var $ = require("jquery");
module.exports = function (element) {

    element = $(element);

    var hiddenSection = element.find("[data-hidden-section]");
    var more = element.find("[data-hidden-section-more]");
    var button = element.find("[data-hidden-section-more-btn]");

    hiddenSection.hide();

    button.on("click", function(ev) {
        ev.preventDefault();
        hiddenSection.show();
        more.hide();
        // TODO: Scroll ?
    });

};


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/controllers/hidden-section.js
// module id = 244
// module chunks = 0